
import React, { useState } from 'react';

interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
}

const AccordionItem: React.FC<AccordionItemProps> = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-slate-200">
      <h2>
        <button
          type="button"
          className="flex items-center justify-between w-full py-5 px-3 text-left font-medium text-slate-700 hover:bg-slate-100 focus:outline-none focus-visible:ring focus-visible:ring-sky-500 focus-visible:ring-opacity-75"
          onClick={() => setIsOpen(!isOpen)}
          aria-expanded={isOpen}
        >
          <span>{title}</span>
          <svg
            className={`w-5 h-5 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </button>
      </h2>
      {isOpen && (
        <div className="pb-5 px-3 text-sm text-slate-600">
          {children}
        </div>
      )}
    </div>
  );
};


interface AccordionProps {
  items: { id: string; question: string; answer: string }[];
}

const Accordion: React.FC<AccordionProps> = ({ items }) => {
  return (
    <div className="w-full max-w-2xl mx-auto bg-white rounded-lg shadow-md">
      {items.map((item) => (
        <AccordionItem key={item.id} title={item.question}>
          {item.answer}
        </AccordionItem>
      ))}
    </div>
  );
};

export default Accordion;
